import { useRef } from 'react'
import { useParallax } from '../hooks/useParallax.js'
import Bg1 from '../assets/img/person/bg-1.jpg'
import Person2 from '../assets/img/person/2.png'

import Logo1 from '../assets/img/logos/1.jpg'
import Logo2 from '../assets/img/logos/2.jpg'
import Logo3 from '../assets/img/logos/3.jpg'

export default function PersonBanner() {
  const sceneRef = useRef(null)
  useParallax(sceneRef)
  return (
    <div className="mil-right-banner" id="scene" ref={sceneRef}>
      <div className="mil-progress-track">
        <div className="mil-progress"></div>
      </div>

      <div className="mil-banner-wrapper" data-depth="1">
        <div id="swupBg" className="mil-banner-frame">
          <img src={Bg1} alt="background" className="mil-banner-bg mil-blur" />
        </div>
      </div>
      <div className="mil-banner-wrapper" data-depth="0.2">
        <div id="swupPerson" className="mil-banner-frame">
          <img src={Person2} alt="person" className="mil-banner-person" />
        </div>
      </div>
      <div className="mil-flying-skills" data-depth="0.1">
        <div id="swupSkills" className="mil-skills-frame">
          <div className="mil-item" style={{ top: '30%', left: '10%' }}>
            <img src={Logo1} alt="logo" />
          </div>
          <div className="mil-item" style={{ bottom: '15%', left: '20%' }}>
            <img src={Logo2} alt="logo" />
          </div>
          <div className="mil-item" style={{ bottom: '45%', right: '15%' }}>
            <img src={Logo3} alt="logo" />
          </div>
          <div className="mil-el mil-addition-el-1">+</div>
          <div className="mil-el mil-addition-el-2">+</div>
          <div className="mil-el mil-addition-el-3"></div>
          <div className="mil-el mil-addition-el-4"></div>
        </div>
      </div>
    </div>
  )
}
